export default __webpack_public_path__ + "static/rf-logo-light-7253d93162cab241f28519f92b7a12d5.svg";